/**
 * Quantities are integer milli-units (architecture.md › Quantities and money): 5.5 L is stored and
 * sent as 5500. Only the UI edge converts to and from human numbers.
 */
export type Qty = number;

export const MILLI = 1000;

/** Human amount (e.g. 5.5) → milli-units (5500). */
export function toQty(amount: number): Qty {
  return Math.round(amount * MILLI);
}

/** Milli-units (5500) → human amount (5.5). */
export function fromQty(qty: Qty): number {
  return qty / MILLI;
}

/**
 * A number in either decimal convention ("5,5", "5.5", "1.250,5", "1,250.5"), or null when the
 * text is not a number.
 */
export function parseDecimal(input: string): number | null {
  let text = input.trim().replace(/[\s  ']/g, "");
  if (text === "") return null;
  const lastComma = text.lastIndexOf(",");
  const lastDot = text.lastIndexOf(".");
  if (lastComma !== -1 && lastDot !== -1) {
    // Both present: the later one is the decimal separator, the other groups thousands.
    const decimal = lastComma > lastDot ? "," : ".";
    const group = decimal === "," ? "." : ",";
    text = text.split(group).join("").replace(decimal, ".");
  } else if (lastComma !== -1) {
    text = text.replace(",", ".");
  }
  if (!/^-?\d*\.?\d+$|^-?\d+\.$/.test(text)) return null;
  const value = Number(text);
  return Number.isFinite(value) ? value : null;
}
